import React from "react";
import {
  Route,
  Switch,
  Redirect,
  withRouter,
} from "react-router-dom";
import classnames from "classnames";
import { withStyles } from '@material-ui/styles';

import Header from "../Header/Header";
import Sidebar from "../Sidebar";

import '../../pages/landingPage/style.css';

// pages
import Corsi from "../../pages/corsi";
import CorsiEliminati from "../../pages/corsiEliminati";
import AddCorso from "../../pages/addCorso";
import EditCorso from "../../pages/editCorso";
import Studenti from "../../pages/studenti";
import AddStudente from "../../pages/addStudente";
import EditStudente from "../../pages/editStudente";
import Aule from "../../pages/aule";
import Notifiche from "../../pages/notifiche";
import AddInsegnante from "../../pages/addInsegnante";
import EditInsegnante from "../../pages/editInsegnante";
import Invoices from "../../pages/invoices";
import AddAula from "../../pages/addAula";
import Insegnanti from "../../pages/insegnanti";
import Schedule from "../../pages/schedule";
import Scuola from "../../pages/scuola";
import GestionePresenze from "../../pages/gestionePresenze";
import AdminSettings from "../../pages/adminsettings";
import PdfCorsoPage from "../../pages/pdfCorsoPage/PdfCorsoPage";
import PdfEsameSingoloPage from "../../pages/pdfEsameSingoloPage/PdfEsameSingoloPage";
import PdfInsegnantiPage from "../../pages/pdfInsegnantiPage";
import PdfFatturatoPage from "../../pages/PdfFatturatoPage";
import PdfInsegnantiGroupPage from "../../pages/pdfInsegnantiGroupPage";
import PdfFullCourse from "../../pages/pdfFullCourse/PdfFullCourse";
import PdfExam from "../../pages/pdfExam/PdfExam";
import PdfSingleStudent from "../../pages/pdfSingleStudent/PdfSingleStudent";
import DetailAula from "../../pages/detailAula/DetailAula";
import PdfAulaPage from "../../pages/pdfAulaPage/PdfAulaPage";
import CorsiBilling from "../../pages/billing/corsi";
import EditCorsoBilling from "../../pages/billing/editCorso/EditCorso";
import EditStudenteBilling from "../../pages/billing/editStudente/EditStudente";
import StudentiBilling from "../../pages/billing/studenti/Studenti";
import Ritirati from "../../pages/billing/ritirati/Ritirati";
import DaVerificare from "../../pages/billing/daVerificare/DaVerificare";
import InRitardo from "../../pages/billing/inRitardo/InRitardo";
import StudenteDetailsBilling from "../../pages/billing/studenteDetails/StudenteDetails";
import InsegnantiBilling from "../../pages/billing/insegnanti/Insegnanti";
import FattureInsegnante from "../../pages/billing/fattureInsegnante/FattureInsegnante";
import FattureInsegnanti from "../../pages/billing/fattureInsegnanti/FattureInsegnanti";
import Dashboard from '../../pages/dashboard/Dashboard';
import DatabaseUsers from '../../pages/databaseUsers/DatabaseUsers';
import UserSettings from "../../pages/usersettings/UserSettings";
import SendFeedback from "../../pages/sendFeedback/SendFeedback";
import RotateDeviceWidget from "../../widgets/RotateDeviceWidget";
import EsameDetails from "../../pages/esameDetails/EsameDetails";
import { getServiceName } from "../../utils/consts";
import translateString from "../../utils/Locales";
import ManageAccount from "../../pages/manageAccount/ManageAccount";
import CheckoutPage from "../../pages/manageAccount/CheckoutPage";
import OrderCompleted from "../../pages/manageAccount/OrderCompleted";
import TicketDetails from "../../pages/sendFeedback/TicketDetails";
import ManagePayments from "../../pages/manageAccount/ManagePayments";
import { ToastContainer } from 'react-toastify';
import './ReactToastify.css';
import PdfInvoice from "../../pages/pdfInvoicePage/PdfInvoicePage";
import ElectronicReceipts from "../../pages/billing/electronicReceipts/ElectronicReceipts";
import Help from "../../pages/Help";

let t = translateString;

const makeStyles = theme => ({
  root: {
    display: "flex",
    maxWidth: "100vw",
    overflowX: "hidden",
  },
  content: {
    flexGrow: 1,
    padding: theme.spacing(3),
    width: `calc(100vw - 240px)`,
    minHeight: "100vh",
  },
  contentShift: {
    width: `calc(100vw - ${240 + theme.spacing(6)}px) `,
    transition: theme.transitions.create(["width", "margin"], {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.enteringScreen,
    }),
  },
  fakeToolbar: {
    ...theme.mixins.toolbar,
  },
});

class Layout extends React.Component {

  constructor(props){
    super(props)

    this.state = {
      menuItems: [], 
      openHelp: false,
      pageHelp: undefined,
    }
  }

  handleResize() {
    if (window.innerWidth < 768 && window.innerHeight > window.innerWidth ) {
      this.setState({ isPortrait: true });
    } else {
      this.setState({ isPortrait: false });
    }
  }

  componentDidMount(){
    window.addEventListener('resize', this.handleResize.bind(this));
    this.currUser = window.sessionStorage.getItem('user_type');
    window.document.title = getServiceName() + ' - ' + t('gestionale')
    this.handleResize();
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.handleResize.bind(this));
  }


  render (){

    // global
    const { classes } = this.props;

    if (this.state.isPortrait) return <RotateDeviceWidget />;

    return (
      
      <div className={classes.root}>
          <>
            <Header isAdmin history={this.props.history} openHelp={(page) => this.setState({ openHelp: true, pageHelp: page }) } />
            <Sidebar menuItems={this.state.menuItems}/>
            <ToastContainer style={{ marginTop: 60 }} />
            <div
              className={classnames(classes.content, {
                [classes.contentShift]: null,
              })}
            >
              <div className={classes.fakeToolbar} />
             
                  <Switch>

                    <Route path="/app/dashboard" component={Dashboard} />
                    <Route path="/app/corsi" component={Corsi} />
                    <Route path="/app/cestinoCorsi" component={CorsiEliminati} />
                    <Route path="/app/addCorso" component={AddCorso} />
                    <Route path="/app/editCorso" component={EditCorso} />
                    <Route path="/app/studenti" component={Studenti} />
                    <Route path="/app/addStudente" component={AddStudente} />
                    <Route path="/app/editStudente" component={EditStudente} />
                    <Route path="/app/insegnanti" component={Insegnanti} />
                    <Route path="/app/addInsegnante" component={AddInsegnante} />
                    <Route path="/app/editInsegnante" component={EditInsegnante} />
                    <Route path="/app/esameDetails" component={EsameDetails} />
                    <Route path="/app/invoices" component={Invoices} />
                    <Route path="/app/aule" component={Aule} />
                    <Route path='/app/detailAula' component={DetailAula} />
                    <Route path="/app/notifiche" component={Notifiche} />
                    <Route path="/app/addAula" component={AddAula} />
                    <Route path="/app/schedule" component={Schedule} />
                    <Route path="/app/scuola" component={Scuola} />
                    <Route path="/app/pdfCorsoPage" component={PdfCorsoPage} />
                    <Route path="/app/PdfInsegnantiPage" component={PdfInsegnantiPage} />
                    <Route path="/app/pdfFatturatoPage" component={PdfFatturatoPage} />
                    <Route path="/app/PdfInsegnantiGroupPage" component={PdfInsegnantiGroupPage} />
                    <Route path="/app/pdfEsameSingoloPage" component={PdfEsameSingoloPage} />
                    <Route path="/app/pdfFullCourse" component={PdfFullCourse} />
                    <Route path="/app/pdfExam" component={PdfExam} />
                    <Route path="/app/pdfSingleStudent" component={PdfSingleStudent} />
                    <Route path="/app/pdfAulaPage" component={PdfAulaPage} />
                    <Route path="/app/gestionePresenze" component={GestionePresenze} />
                    <Route path="/app/adminSettings" component={AdminSettings} />
                    <Route path="/app/users" component={DatabaseUsers} />
                    <Route path="/app/userSettings" component={UserSettings} />
                    <Route path="/app/account" component={ManageAccount} />
                    <Route path="/app/checkout" component={CheckoutPage} />
                    <Route path="/app/payments" component={ManagePayments} />
                    <Route path="/app/complete" component={OrderCompleted} />
                    <Route path="/app/sendFeedback" component={SendFeedback} />
                    <Route path="/app/ticketDetails" component={TicketDetails} />

                    <Route path="/billing/corsi" component={CorsiBilling} />
                    <Route path="/billing/editCorso" component={EditCorsoBilling} />
                    <Route path="/billing/editStudente" component={EditStudenteBilling} />
                    <Route path="/billing/invoicePdf" component={PdfInvoice} />

                    <Route path="/billing/studenti" component={StudentiBilling} />
                    <Route path="/billing/ritirati" component={Ritirati} />
                    <Route path="/billing/studenteDetails" component={StudenteDetailsBilling} />

                    <Route path="/billing/daVerificare" component={DaVerificare} />
                    <Route path="/billing/inRitardo" component={InRitardo} />

                    <Route path="/billing/insegnanti" component={InsegnantiBilling} />
                    <Route path="/billing/fattureInsegnante" component={FattureInsegnante} />
                    <Route path="/billing/fattureInsegnanti" component={FattureInsegnanti} />

                    <Route path="/billing/electronicReceipts" component={ElectronicReceipts} />
                
                    <Route
                      exact
                      path="/app/ui"
                      render={() => <Redirect to="/app/ui/icons" />}
                    />
                  </Switch>
            </div>

            { this.state.openHelp && (
                <Help page={this.state.pageHelp} onClose={() => this.setState({ openHelp: false, pageHelp: undefined })} x={window.innerWidth - 600} y={80} />
            )}

            <div
              className={classnames(classes.contentPhone)}
            >
            </div>
            <div className="lang-btn" style={{ position: 'fixed', top: 25, right: 150, zIndex: 2000 }} onClick={() => { this.setState({ }); window.sessionStorage.setItem('lang', 'it') }}><img src={ require('../../images/it.png') } style={{ width: 20, height: 'auto' }}/></div>
            <div className="lang-btn" style={{ position: 'fixed', top: 25, right: 120, zIndex: 2000 }} onClick={() => { this.setState({ }); window.sessionStorage.setItem('lang', 'en') }}><img src={ require('../../images/en.png') } style={{ width: 20, height: 'auto' }}/></div>
          </>

      </div>
    );
  }
  
}

export default withStyles(makeStyles)(withRouter(Layout));
